import {
  GetUserProfileDocument,
  GetUserProfileQuery,
  SaveUserProfileDocument,
  SaveUserProfileInput,
  SaveUserProfileMutation,
  UpdateUserProfileDocument,
  UpdateUserProfileInput,
  UpdateUserProfileMutation,
} from "../generated/graphql";
import { client } from "./client";

export const getUserProfile = async () => {
  return (
    await client.query<GetUserProfileQuery>({
      query: GetUserProfileDocument,
    })
  ).data.getUserProfile;
};

export const saveUserProfile = async (param: SaveUserProfileInput) => {
  return (
    await client.mutate<SaveUserProfileMutation>({
      mutation: SaveUserProfileDocument,
      variables: {
        param: {
          ...param,
        },
      },
    })
  ).data?.saveUserProfile;
};

export const updateUserProfile = async (param: UpdateUserProfileInput) => {
  return (
    await client.mutate<UpdateUserProfileMutation>({
      mutation: UpdateUserProfileDocument,
      variables: {
        param: {
          ...param,
        },
      },
    })
  ).data?.updateUserProfile;
};
